module.exports = __webpack_public_path__ + "static/img/services-2.c893de3.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/services-2.png
// module id = u2NX
// module chunks = 1